// extracted by mini-css-extract-plugin
export default {"emptyTable":"Filter_emptyTable__l3nB9","emptyTableImg":"Filter_emptyTableImg__tfdcS"};